import { ChangeDetectionStrategy, Component, EventEmitter, Output, computed, isDevMode, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { isPlausiblePhone, isValidEmail } from '../../utils/form-validators';

@Component({
  selector: 'app-insolvency-modal',
  standalone: true,
  imports: [FormsModule, TranslatePipe],
  templateUrl: './insolvency-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsolvencyModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() submitInsolvency = new EventEmitter<Record<string, string | null>>();
  readonly showDevHelper = isDevMode();
  readonly fields = ['email', 'telefon', 'address', 'procedure_status', 'case_number', 'court',
    'administrator_name', 'administrator_contact', 'debt_counselling'];
  readonly values = signal<Partial<Record<string, string>>>({});
  readonly submitAttempted = signal(false);
  readonly isValid = computed(() => isValidEmail(this.values()['email'] ?? '')
    && (!this.values()['telefon']?.trim() || isPlausiblePhone(this.values()['telefon'] ?? ''))
    && (!this.values()['procedure_status'] || ['yes', 'no', 'unknown'].includes(this.values()['procedure_status']!))
    && this.fields.every((field) => (this.values()[field] ?? '').trim().length <= 120));

  setValue(field: string, value: string): void {
    this.values.update((values) => ({ ...values, [field]: value }));
  }

  insertTestData(): void {
    if (!this.showDevHelper) return;
    this.values.set({
      email: 'debtor@example.test', telefon: '+49 151 23456789', address: 'Musterstraße 1, 12345 Musterstadt',
      procedure_status: 'yes', case_number: 'IN 123/26', court: 'Amtsgericht Musterstadt',
      administrator_name: 'Musterverwaltung', administrator_contact: 'trustee@example.test',
      debt_counselling: 'Musterberatung',
    });
  }

  onSubmit(): void {
    this.submitAttempted.set(true);
    if (!this.isValid()) return;
    this.submitInsolvency.emit(Object.fromEntries(this.fields.map((field) =>
      [field, this.values()[field]?.trim() || null])));
  }
}
